import stringReplace from "react-string-replace";
import Highlight from "../components/Highlight";
import { output } from "../content/copy";

const replace = (regex, Component, props = {}) => (text) =>
  stringReplace(text, new RegExp(regex, "gi"), (match, i) => (
    <>
      {" "}
      <Component {...props}>{match}</Component>{" "}
    </>
  ));

const sortOutString = (text) => {
  const withMale = replace(` (${output.male.join("|")}) `, Highlight, {
    type: "masculine",
  });

  const withFemale = replace(` (${output.female.join("|")}) `, Highlight, {
    type: "feminine",
  });

  const withBold = replace(`<strong>(.+)</strong>`, ({ children, ...rest }) => (
    <strong {...rest}>{children}</strong>
  ));

  return withBold(withFemale(withMale(text)));
};

const getResultsText = (resultsText, maleCount, femaleCount) => {
  const total = maleCount + femaleCount;

  if (total === 0) {
    return sortOutString(resultsText.none);
  }

  if (total > 0 && femaleCount === maleCount) {
    return sortOutString(resultsText.balance);
  }

  if (maleCount > femaleCount) {
    return sortOutString(resultsText.moreMale);
  }

  if (femaleCount > maleCount) {
    return sortOutString(resultsText.moreFemale);
  }
};

export default getResultsText;
